import React from "react";

function GradientSlider({ value, onChange }) {
    const ideologyMap = {
        "-4": "Extreme Liberal",
        "-3": "Very Liberal",
        "-2": "Moderate Liberal",
        "-1": "Left of Center",
        "0": "Centrist",
        "1": "Right of Center",
        "2": "Moderate Conservative",
        "3": "Very Conservative",
        "4": "Extreme Conservative",
    };

    const handleChange = (e) => {
        const newValue = Number(e.target.value);
        onChange(newValue);
    };

    return React.createElement(
        "div",
        { className: "slider-container" },
        React.createElement(
            "div",
            { className: "slider-value" },
            ideologyMap[value.toString()]
        ),
        React.createElement("input", {
            type: "range",
            min: -4,
            max: 4,
            step: 1,
            value: value,
            onChange: handleChange,
            className: "slider",
        }),
        //React.createElement(
        //    "div",
        //    { className: "slider-labels" },
        //    React.createElement("span", { className: "slider-label-left" }, "Liberal"),
        //    React.createElement("span", { className: "slider-label-center" }, "Centrist"),
        //    React.createElement("span", { className: "slider-label-right" }, "Conservative")
        //)
    );
}

export default GradientSlider;
